import * as React from 'react';

import * as css from './centeredWrapper.module.css';

interface Props {
  children: React.ReactNode;
}

export function CenteredWrapper({ children }: Props) {
  return <div className={css.root}>{children}</div>;
}
